import { createAction } from "@reduxjs/toolkit";

export const ADD_MUTUI_BY_ID = createAction("requests/mutui/add-static-mutui");
export const SET_HAS_PERFORM_LOADING = createAction(
  "requests/mutui/set-perform-loading"
);
